import script from "./MbTheFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MbTheFooter.vue?vue&type=script&setup=true&lang=ts"

import "./MbTheFooter.vue?vue&type=style&index=0&id=a915793c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a915793c"]])

export default __exports__